// extracted by mini-css-extract-plugin
module.exports = {"leadingSection":"styles_leadingSection__9zCVk","footerDescription":"styles_footerDescription__DmqdB","footerDescriptionText":"styles_footerDescriptionText__laqQ_"};